<template>
  <b-form-group
    label-cols="3"
    label-size="sm"
    label="Rows per page:"
    label-for="rows-per-page"
  >
    <b-input-group>
      <b-input
        id="rows-per-page"
        :value="value"
        type="number"
        min="1"
        :max="max"
        label="Rows per page"
        @input="$emit('input', Number($event))"
      />
      <b-input-group-append>
        <b-button
          variant="primary"
          @click="$emit('getAll')"
        >
          All
        </b-button>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  value: {
    type: Number,
    required: true,
  },
  max: {
    type: Number,
    required: true,
  },
}

@Component
export default class FilterRowsPerPage extends Vue.extend({ props }) {}

</script>
